<template>
  <div
    v-if="critereRecherche"
    class="columns is-multiline is-marginless is-main-content is-paddingless">
    <div class="column is-12 pdb-0 hauteur-haut-brief-filtre">
      <div class="column is-12 mgt-5px">
        <a @click="$emit('toggleFiltre')">
          <b-icon class="icon is-pulled-right has-text-icon-more" icon="close"></b-icon>
        </a>
        <span class="has-text-weight-bold is-size-4">
          {{ $t('general.filtre.title') }}
        </span>
      </div>
      <div class="column is-12 pdt-0">
        <span class="has-text-icon-more is-size-7">
          {{ $t('general.filtre.sousTitle') }}
        </span>
      </div>
    </div>
    <div class="column is-12 is-marginless overflow-auto hauteur-brief-filtre">
      <div class="columns is-marginless is-multiline">
        <div class="column is-12 pdb-0">
          <b-field :label="$t('listeFactureAchatFournisseur.filtre.code')">
            <qd-taginput
              v-model="critereRecherche.codes"
              type="is-primary">
            </qd-taginput>
          </b-field>
        </div>
        <div class="column is-12 pdb-0">
          <query-tiers-tag-input
            v-model="critereRecherche.tiersId"
            :label="$t('listeFactureAchatFournisseur.filtre.fournisseur')"
            :societeActiveId="societeActiveId"
            :sousTypes="constantes.SOUS_TYPE_FOURNISSEUR"
            typologie="all">
          </query-tiers-tag-input>
        </div>
        <div class="column is-12 pdb-0">
          <input-periode
            v-model="critereRecherche.dates"
            :label="$t('listeFactureAchatFournisseur.filtre.dateDevisCommande')">
         </input-periode>
        </div>
        <div class="column is-12 pdb-0">
          <libelle-tag-input
            v-model="critereRecherche.etat"
            :label="$t('listeFactureAchatFournisseur.filtre.etat')"
            :items="constantes.FACTURE_ETAT">
          </libelle-tag-input>
        </div>
        <div class="column is-12 pdb-0">
          <agence-tag-input
            v-model="critereRecherche.agencesId"
            :label="$t('listeFactureAchatFournisseur.filtre.agence')"
            :items="agencesSelectionnees">
          </agence-tag-input>
        </div>
      </div>
    </div>
    <div class="column is-12 border-pied pdt-0 hauteur-bas-brief-filtre">
      <button
        class="button mgl-10px mgt-10px is-addOrEdit has-text-white"
        @click="appliquerCritere()">
        {{$t('general.button.apply')}}
      </button>
      <button
        class="button border-none mgt-10px has-text-icon-more pd-10px"
        @click="viderCritere()">
        {{$t('general.button.reinitialiser')}}
      </button>
    </div>
  </div>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep';
import { createNamespacedHelpers } from 'vuex';
import { SET_CRITERE_RECHERCHE } from '@/store/modules/achat/fournisseurSupport-mutation-type';
import { FACTURE_ETAT } from '@/configuration/facture/factureConf';
import { LISTE_SOUS_TYPE_FOURNISSEURS_PAGES } from '@/configuration/tiers/tiersConf';
import genererCritereRecherche from '@/services/achat/commandes/genererCritereRecherche';
import InputPeriode from '@/components/general/inputPeriode';
import AgenceTagInput from '@/components/general/tagInput/agenceTagInput';
import LibelleTagInput from '@/components/general/tagInput/libelleTagInput';
import QueryTiersTagInput from '@/components/general/tagInput/queryTiersTagInput';

const Societe = createNamespacedHelpers('societe');

export default {
  components: {
    InputPeriode,
    AgenceTagInput,
    LibelleTagInput,
    QueryTiersTagInput,
  },
  data() {
    return {
      nameStore: 'facturesAchatsFournisseur',
      critereRecherche: null,
      constantes: {
        FACTURE_ETAT,
        SOUS_TYPE_FOURNISSEUR: LISTE_SOUS_TYPE_FOURNISSEURS_PAGES.map((el) => el.code),
      },
    };
  },
  computed: {
    ...Societe.mapGetters({
      agencesSelectionnees: 'agenceActive',
      societeActiveId: 'societeActiveId',
    }),
    critereRechercheFromStore: {
      get() {
        return this.$store.getters[`${this.nameStore}/criteresRecherche`];
      },
      set(value) {
        this.$store.commit(`${this.nameStore}/${SET_CRITERE_RECHERCHE}`, value);
      },
    },
  },
  methods: {
    viderCritere() {
      const critereRecherche = genererCritereRecherche();
      this.critereRecherche = critereRecherche;
    },
    appliquerCritere() {
      this.critereRechercheFromStore = this.critereRecherche;
      this.$emit('recherche');
    },
    initializeFiltre() {
      const critereRecherche = cloneDeep(this.critereRechercheFromStore);
      this.critereRecherche = critereRecherche;
    },
  },
  mounted() {
    this.initializeFiltre();
  },
};
</script>
